'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.icons = undefined;

var _icons = require('./icons');

Object.defineProperty(exports, 'icons', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_icons).default;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled icon wrapper
 * Adds basic color and sizing logic
 * @private
 */
var StyledIcon = exports.StyledIcon = _styledComponents2.default.span.withConfig({
  displayName: 'src__StyledIcon'
})(['display:inline-flex;font-size:', ';svg,circle,rect,path,g{fill:currentColor;}svg{height:1em;width:1em;}'], function (_ref) {
  var size = _ref.size;
  return size || '1em';
});

/**
 * Icon
 * Creates an SVG icon
 * @public
 * @param {Object} props
 *   The properties
 * @param {ReactElement} props.icon
 *   An SVG icon
 * @param {(ReactElement|ReactElement[])} props.children
 *   If children are provided the `icon` is ignored
 * @param {String} props.size
 *   size of the icon plus unit (e.g. 1rem)
 */
var Icon = function Icon(_ref2) {
  var children = _ref2.children,
      icon = _ref2.icon,
      _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? '1em' : _ref2$size;
  return _react2.default.createElement(
    StyledIcon,
    { size: size },
    children || icon
  );
};

/**
 * @private
 */
Icon.propTypes = {
  children: _propTypes2.default.node,
  icon: _propTypes2.default.node,
  size: _propTypes2.default.string

  /**
   * @private
   */
};Icon.defaultProps = {
  children: null,
  icon: null,
  size: '1em'
};

exports.default = Icon;
//# sourceMappingURL=index.js.map